import { ProductBillOfMaterial } from '../ProductBillOfMaterial'
import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class CloneProductArgs extends ActionArgs {
  @Field(() => String)
  productId: string

  @Field(() => String, { nullable: true })
  code?: string

  @Field(() => [ProductBillOfMaterial], { nullable: true })
  bom?: ProductBillOfMaterial[]
}
